// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rnBL_kgdScElw4TxLxkl{grid-template-columns:max-content 1fr;gap:4px;display:grid}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `rnBL_kgdScElw4TxLxkl`
};
export default ___CSS_LOADER_EXPORT___;
